<template>
    <div class="wechat-red-packet-main">
        <div class="red-packet__stage">
            <div class="red-packet__halo"></div>

            <div class="red-packet__envelope">
                <div class="red-packet__seal">
                    <van-icon name="balance-o" />
                </div>
                <div class="red-packet__content">
                    <div class="red-packet__eyebrow">微信红包</div>
                    <div class="red-packet__title">{{pageTitle}}</div>
                    <div class="red-packet__subtitle">{{pageSubtitle}}</div>
                </div>
            </div>

            <div class="red-packet__status" v-if="statusText">
                <van-loading v-if="loading" size="18px" color="#8a5a16" />
                <van-icon v-else-if="errorMessage" name="warning-o" />
                <van-icon v-else name="passed" />
                <span>{{statusText}}</span>
            </div>

            <div class="red-packet__form">
                <van-field
                    v-model="phone"
                    type="tel"
                    maxlength="11"
                    clearable
                    placeholder="请输入手机号"
                >
                    <template #left-icon>
                        <van-icon name="phone-o" />
                    </template>
                </van-field>
                <div class="red-packet__captcha-row">
                    <van-field
                        v-model="captcha"
                        type="number"
                        maxlength="6"
                        clearable
                        placeholder="请输入短信验证码"
                    >
                        <template #left-icon>
                            <van-icon name="comment-o" />
                        </template>
                    </van-field>
                    <van-button
                        class="red-packet__captcha-button"
                        round
                        :disabled="captchaButtonDisabled"
                        :loading="captchaLoading"
                        @click="fetchCaptcha"
                    >
                        {{captchaButtonText}}
                    </van-button>
                </div>
            </div>

            <van-button
                class="red-packet__button"
                block
                round
                :loading="loading"
                loading-text="拉起中"
                @click="onReceiveRedPacket"
            >
                领取红包
            </van-button>

            <div class="red-packet__tips">
                红包将通过微信官方页面完成领取
            </div>
        </div>
    </div>
</template>

<script>
import {Loading, Button, Icon, Field} from "vant";
import wechat from "@/utils/wechat.js";
import request from "@/utils/request.js";

function isValidMobile(phone) {
    return /^1[3-9]\d{9}$/.test(phone);
}

function encodeSpm(phone) {
    return Buffer.from(phone).toString("base64");
}

const SMS_SCENE_CODE = "H5_RedPacket";
export default {
    name: "WechatRedPacket",
    components: {
        [Loading.name]: Loading,
        [Button.name]: Button,
        [Icon.name]: Icon,
        [Field.name]: Field
    },
    data() {
        return {
            loading: false,
            captchaLoading: false,
            captchaCountdown: 0,
            captchaTimer: undefined,
            errorMessage: "",
            phone: "",
            captcha: ""
        };
    },
    computed: {
        pageTitle() {
            return "恭喜获得红包";
        },
        pageSubtitle() {
            return "点击领取后进入微信领取页面";
        },
        captchaButtonDisabled() {
            return this.captchaLoading || this.captchaCountdown > 0;
        },
        captchaButtonText() {
            if (this.captchaCountdown > 0) {
                return `${this.captchaCountdown}s`;
            }
            return "获取验证码";
        },
        statusText() {
            if (this.loading) {
                return "正在准备领取环境";
            }
            if (this.errorMessage) {
                return this.errorMessage;
            }
            return "";
        }
    },
    beforeDestroy() {
        this.clearCaptchaTimer();
    },
    methods: {
        getSmsSceneCode() {
            return SMS_SCENE_CODE;
        },
        getSmsFetchUrl() {
            const spm = encodeURIComponent(encodeSpm(this.phone));
            const sceneCode = encodeURIComponent(this.getSmsSceneCode());
            return `/customer/sms/captcha/fetch?spm=${spm}&sceneCode=${sceneCode}`;
        },
        getSmsCheckUrl() {
            const spm = encodeURIComponent(encodeSpm(this.phone));
            const sceneCode = encodeURIComponent(this.getSmsSceneCode());
            const captcha = encodeURIComponent(this.captcha);
            return `/customer/sms/captcha/check?spm=${spm}&sceneCode=${sceneCode}&captcha=${captcha}`;
        },
        clearCaptchaTimer() {
            if (this.captchaTimer) {
                window.clearInterval(this.captchaTimer);
                this.captchaTimer = undefined;
            }
        },
        startCaptchaCountdown() {
            this.clearCaptchaTimer();
            this.captchaCountdown = 60;
            this.captchaTimer = window.setInterval(() => {
                if (this.captchaCountdown <= 1) {
                    this.captchaCountdown = 0;
                    this.clearCaptchaTimer();
                    return;
                }
                this.captchaCountdown -= 1;
            }, 1000);
        },
        validatePhone() {
            if (!this.phone) {
                this.$notify({message: "请输入手机号", type: "warning"});
                return false;
            }
            if (!isValidMobile(this.phone)) {
                this.$notify({message: "请输入正确的手机号", type: "warning"});
                return false;
            }
            return true;
        },
        async fetchCaptcha() {
            if (!this.validatePhone()) {
                return;
            }
            this.captchaLoading = true;
            try {
                await request.get(this.getSmsFetchUrl());
                this.$notify({message: "验证码已发送", type: "success"});
                this.startCaptchaCountdown();
            } catch (e) {
                this.$notify({message: "获取验证码失败", type: "danger"});
            } finally {
                this.captchaLoading = false;
            }
        },
        async checkCaptcha() {
            await request.get(this.getSmsCheckUrl());
        },
        validateReceiveParams() {
            if (!this.validatePhone()) {
                return false;
            }
            if (!this.captcha) {
                this.$notify({message: "请输入短信验证码", type: "warning"});
                return false;
            }
            return true;
        },
        async collectPendingPublishRecord() {
            const {data} = await request.post("/redPacket/collectPendingPublishRecord", {
                data: {
                    phone: this.phone
                }
            });
            return data;
        },
        async onReceiveRedPacket() {
            if (!this.validateReceiveParams()) {
                return;
            }
            this.loading = true;
            this.errorMessage = "";
            try {
                await this.checkCaptcha();
            } catch (e) {
                this.loading = false;
                this.$notify({message: "短信验证码校验失败", type: "danger"});
                return;
            }
            try {
                const collectResult = await this.collectPendingPublishRecord();
                this.openWechatTransfer(collectResult);
            } catch (e) {
                this.loading = false;
                this.$notify({message: e.message || "红包领取记录提交失败", type: "danger"});
            }
        },
        openWechatTransfer(collectResult) {
            this.errorMessage = "";
            try {
                if (!collectResult) {
                    throw new Error("红包接口未返回领取结果");
                }
                if (collectResult.redPacketIssued === false) {
                    this.loading = false;
                    this.$notify({message: "您已登记成功，等待平台审核", type: "success"});
                    return;
                }
                if (collectResult.redPacketIssued !== true) {
                    throw new Error("红包接口返回状态异常");
                }

                const issueResp = collectResult.issueResp;
                const action = issueResp && issueResp.action;
                const packageInfo = action && action.packageInfo;
                if (!packageInfo) {
                    throw new Error("红包接口未返回领取参数");
                }

                this.loading = true;
                wechat.triggerWechatTransfer(packageInfo, res => {
                    this.loading = false;
                    const errMsg = res && (res.err_msg || res.errMsg);
                    if (errMsg && errMsg.indexOf(":ok") === -1) {
                        this.errorMessage = errMsg;
                    }
                }, {mchId: collectResult.mchId, appId: collectResult.appId});

            } catch (e) {
                this.loading = false;
                this.errorMessage = e.message || "拉起微信领取页面失败";
                this.$notify({message: this.errorMessage, type: "danger"});
            }
        }
    }
};
</script>

<style lang="less">
@import "@/style/base.less";

.wechat-red-packet-main {
    min-height: 100vh;
    background:
        radial-gradient(circle at 50% 14%, #ffd985 0, #ffd985 11%, transparent 32%),
        linear-gradient(180deg, #c82020 0%, #e63726 42%, #f5f0e8 42%, #f5f0e8 100%);
    overflow: hidden;
}

.red-packet__stage {
    position: relative;
    min-height: 100vh;
    padding: 32px 22px 24px;
    box-sizing: border-box;
}

.red-packet__halo {
    position: absolute;
    top: 28px;
    left: 50%;
    width: 260px;
    height: 260px;
    transform: translateX(-50%);
    border-radius: 50%;
    border: 1px solid rgba(255, 230, 160, .42);
    box-shadow: 0 0 0 24px rgba(255, 218, 119, .08), 0 0 0 48px rgba(255, 218, 119, .04);
}

.red-packet__envelope {
    position: relative;
    z-index: 1;
    margin: 34px auto 0;
    max-width: 332px;
    min-height: 390px;
    border-radius: 8px;
    background: linear-gradient(180deg, #df2821 0%, #b81718 100%);
    box-shadow: 0 18px 36px rgba(115, 30, 18, .28);
    overflow: hidden;
}

.red-packet__envelope::before {
    content: "";
    position: absolute;
    top: -128px;
    left: -42px;
    width: 416px;
    height: 260px;
    border-radius: 0 0 50% 50%;
    background: linear-gradient(180deg, #ff6148 0%, #df2d25 100%);
    border-bottom: 1px solid rgba(122, 18, 18, .22);
}

.red-packet__envelope::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -78px;
    height: 210px;
    border-radius: 50% 50% 0 0;
    background: linear-gradient(180deg, #c51d1d 0%, #a81416 100%);
}

.red-packet__seal {
    position: absolute;
    z-index: 2;
    top: 103px;
    left: 50%;
    width: 76px;
    height: 76px;
    transform: translateX(-50%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7e4110;
    font-size: 34px;
    background: linear-gradient(180deg, #ffe29c 0%, #d89936 100%);
    box-shadow: 0 8px 14px rgba(87, 26, 11, .22);
}

.red-packet__content {
    position: relative;
    z-index: 3;
    padding: 206px 24px 32px;
    text-align: center;
}

.red-packet__eyebrow {
    color: #ffd894;
    font-size: @font-size-mini;
    line-height: @line-height-mini;
}

.red-packet__title {
    margin-top: 4px;
    color: #fff8e6;
    font-size: 25px;
    line-height: 34px;
    font-weight: 600;
}

.red-packet__subtitle {
    margin-top: 10px;
    color: rgba(255, 247, 223, .78);
    font-size: @font-size-normal;
    line-height: @line-height-normal;
}

.red-packet__status {
    min-height: 28px;
    margin: 18px auto 0;
    max-width: 332px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7e4110;
    font-size: @font-size-normal;
    line-height: @line-height-normal;

    .van-loading,
    .van-icon {
        margin-right: 6px;
    }
}

.red-packet__form {
    max-width: 332px;
    margin: 14px auto 0;

    .van-cell {
        min-height: 46px;
        align-items: center;
        padding: 0 14px;
        border-radius: 8px;
        background: #fffaf0;
        border: 1px solid rgba(215, 154, 56, .36);
        box-shadow: 0 6px 14px rgba(120, 73, 18, .08);
    }

    .van-cell::after {
        display: none;
    }

    .van-field__left-icon {
        color: #a96319;
        margin-right: 8px;
    }

    .van-field__control {
        color: #4d3933;
        font-size: @font-size-normal;
    }

    .van-field__control::placeholder {
        color: #b7a68d;
    }
}

.red-packet__captcha-row {
    display: flex;
    align-items: center;
    margin-top: 10px;

    .van-field {
        flex: 1;
        min-width: 0;
    }
}

.red-packet__captcha-button {
    flex: 0 0 104px;
    height: 46px;
    margin-left: 10px;
    padding: 0;
    border: 1px solid rgba(126, 65, 16, .28);
    color: #7e4110;
    background: #fff1c9;
    font-size: @font-size-normal;
}

.red-packet__button {
    margin: 16px auto 0;
    max-width: 332px;
    height: 48px;
    border: none;
    color: #7e4110;
    font-size: @font-size-title;
    font-weight: 600;
    background: linear-gradient(180deg, #ffe7a4 0%, #d79a38 100%);
    box-shadow: 0 8px 18px rgba(120, 73, 18, .22);
}

.red-packet__tips {
    margin-top: 14px;
    color: #8c806c;
    font-size: @font-size-mini;
    line-height: @line-height-mini;
    text-align: center;
}
</style>
